import React, { FC } from 'react';

import CustomIcon from '@components/utils/CustomIcon';
import { DeleteBin5Line, LocationPinIcon, PlaneFill } from '@assets/icons';
import { ClearSearchButton } from '@components/views/landing/components/booker/common/styled';
import { AirportSearchViewModel } from '@api/index';

import {
  LabelWrapper,
  ResponsiveLocationListItem,
  ResponsiveLocationListItemContent,
  ResponsiveLocationListItemIcon,
  SearchLabel,
  SearchSubLabel,
} from './styled';

interface ILocationResultItem {
  locationData: AirportSearchViewModel;
  onClick: () => void;
  isHistoryData: boolean;
  onRemoveHistoryData?: () => void;
}

const LocationResultItem: FC<ILocationResultItem> = ({
  locationData,
  onClick,
  isHistoryData,
  onRemoveHistoryData,
}) => {
  return (
    <ResponsiveLocationListItem key={locationData?.airportId}>
      <ResponsiveLocationListItemContent onClick={onClick}>
        <ResponsiveLocationListItemIcon>
          <CustomIcon
            paletteColor='grey600'
            icon={locationData?.isCity ? LocationPinIcon : PlaneFill}
            fontSize={20}
          />
        </ResponsiveLocationListItemIcon>
        <LabelWrapper>
          <SearchLabel>
            {locationData?.airportName + ', ' + locationData?.airportCode}
          </SearchLabel>
          <SearchSubLabel>
            {locationData?.cityName +
              ',' +
              locationData?.countryName +
              '(' +
              locationData?.airportCode +
              ')'}
          </SearchSubLabel>
        </LabelWrapper>
      </ResponsiveLocationListItemContent>

      {isHistoryData ? (
        <ClearSearchButton onClick={onRemoveHistoryData}>
          <CustomIcon
            paletteColor='grey600'
            icon={DeleteBin5Line}
            fontSize={16}
          />
        </ClearSearchButton>
      ) : null}
    </ResponsiveLocationListItem>
  );
};

export default LocationResultItem;
